export const buildGitHubPath = dirName => dirName ? "https://github.com/certego/certego-ui/tree/main/src/components/" + dirName : "";

export const capitalize = str => str?.length ? str.charAt(0).toUpperCase() + str.slice(1) : "";

